import { CompositeTilemap } from "@pixi/tilemap"
import { BLEND_MODES, Renderer } from "pixi.js"

/**
 * A CompositeTilemap that draws with normal blending.
 *
 * @pixi/tilemap never sets the blend state; it draws with whatever the previous object left, which
 * can be an additive sprite from the end of the last frame. Every tile layer was then ADDED onto the
 * ones below it, so straw over grass came out yellow-green. A filter pass just before the tile layers
 * used to reset the state by accident.
 */
export class NormalBlendTilemap extends CompositeTilemap {
    render(renderer: Renderer): void {
        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) return
        // Flush what is already batched under its own blend modes before taking over the state.
        renderer.batch.setObjectRenderer((renderer.plugins as any).tilemap)
        renderer.state.setBlendMode(BLEND_MODES.NORMAL)
        super.render(renderer)
    }
}
